<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="mat-typography">
  <page-alert *ngIf="submittedSchedule && showSuccessMessage" message="Agendamento realizado com sucesso" alertClass="alert-success"></page-alert>

  <page-alert
    *ngIf="submittedSchedule && showErrorMessage"
    message="Falha ao realizar Agendamento. Tente novamente!"
    alertClass="alert-danger"
  ></page-alert>

  <div *ngIf="type == 'Consulta'">
    <page-data-person [person]="practitioner" type="Consulta"></page-data-person>
    <page-alert [message]="getPaymentText()"></page-alert>
    <page-map-view [address]="practitioner?.address ? practitioner?.address : practitioner?.address[0]"></page-map-view>
  </div>
  <div *ngIf="type == 'Exame'">
    <div [innerHTML]="procedure.description"></div>
    <page-title [title]="subtitles[0]"></page-title>
    <div [innerHTML]="procedure.orientations"></div>
    <div *ngIf="organization">
      <page-title [title]="subtitles[1]"></page-title>
      <div>{{ organization?.name ? organization?.name : address.name || 'Undefined' }}</div>
      <div [innerHTML]="openingHoursText"></div>
      <div class="row contacts">
        <div class="col-xs-12 col-md-4">
          <mat-icon color="primary">mail</mat-icon>
          {{ organization?.mail ? organization.mail : address.mail || 'Undefined' }}
        </div>
        <div class="col-xs-12 col-md-4">
          <mat-icon color="primary">call</mat-icon>
          {{ organization?.phone ? organization.phone : address.phone || 'Undefined' }}
        </div>
      </div>
      <page-map-view [address]="organization?.address ? organization?.address : address || {}"></page-map-view>
      <page-alert [message]="getPaymentText()"></page-alert>
    </div>
  </div>
  <div class="row" *ngIf="currentUser.type == 'secretary'">
    <div class="col-xs-12 col-md-9 col-lg-10">
      <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 15px">
        <mat-label>Selecione o paciente</mat-label>
        <mat-select [(ngModel)]="schedule.patient">
          <mat-option *ngFor="let item of patients" [value]="item">
            {{ item.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="hasError('patient')"> Campo obrigatório </mat-error>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-3 col-lg-2">
      <div class="btNew"><button mat-flat-button color="primary" (click)="openPatientForm()" [disabled]="loading">Novo paciente</button></div>
    </div>
  </div>
  <div class="col-xs-6 col-md-9 col-lg-10" *ngIf="type == 'Exame'">
    <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 15px">
      <mat-label>Selecione o especialista</mat-label>
      <mat-select [(ngModel)]="schedule.practioner">
        <mat-option *ngFor="let item of practitioners" [value]="item">
          {{ item.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="hasError('patient')"> Campo obrigatório </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="primary" (click)="saveSchedule()">Salvar</button>
</mat-dialog-actions>
